"use client";

import { FC } from "react";

const ContentTranslatedBanner: FC<{ forceVisible?: boolean }> = () => {
  return null;
};

export default ContentTranslatedBanner;
